import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { TabItem } from '../models/admin.model';

@Injectable({
	providedIn: 'root'
})
export class AdminService {

	constructor(
		private cvApiService: CVApiService,
	) { }

	async loadAvailableTabs(): Promise<TabItem[]> {
		try {
			const url = "/api/v2/admin/tabs";
			const response = await this.cvApiService.get<TabItem[]>(url);
			if (response.status_code >= 200 && response.status_code < 300) {
				return response.data;
			} else {
				throw response;
			}
		} catch (error) {
			console.error("Failed getting data for admin tabs");
			throw error;
		}
	}
}
